<template>
  <sliding-window>
    <div slot="panel">
      <violet-bar>Fichettes A5</violet-bar>
      <div class="squarebox">
        <div class="field">
          <div class="control">
            <button
              class="button"
              @click="print"
              :class="loading ? 'is-loading' : ''"
            >
              <i class="fa fa-print"></i>&nbsp;imprimer (serveur)
            </button>
            &nbsp;
            <button class="button" @click="printManual">
              <i class="fa fa-print"></i>&nbsp;imprimer (manuel)
            </button>
          </div>
        </div>
        <hr />
        <div class="control" v-if="render">
          <div class="RenderPreview">
            <img
              class="RenderPreview__img"
              :src="render.thumbnail.public_path"
            />
          </div>
          <a class="button is-info" :href="render.friendly_path" target="_blank"
            >Télécharger</a
          >
        </div>
        <hr />
        <div class="control">
          <router-link :to="'/home'"
            ><i class="fa fa-arrow-left"></i> accueil
          </router-link>
        </div>
      </div>
    </div>
    <page-format-handler :format="'A4'" :orientation="'landscape'">
      <page
        v-for="chunk in chunkedProjects"
        :key="chunk[0].uuid"
        :format="'A4'"
        :orientation="'landscape'"
      >
        <page-inner style="color: #31287c">
          <div class="FichettesA5">
            <Fichette :p="chunk[0]" v-if="chunk.length > 0"/>
            <Fichette :p="chunk[1]" v-if="chunk.length > 1"/>
          </div>
        </page-inner>
      </page>
    </page-format-handler>
  </sliding-window>
</template>

<script>
  import SlidingWindow from "../PrintComponents/Workspace/SlidingWindow";
  import {types as t} from "../../../store/actions/projects";
  import {get, rem} from "../../../storage/storage";
  import {types} from "../../../store/actions/render";
  import PageFormatHandler from "../PrintComponents/Page/PageFormatHandler";
  import PageInner from "../PrintComponents/Page/PageInner";
  import Page from "../PrintComponents/Page/Page";
  import {formatDateFrench, formatNumbers, mapNames} from "../../../util/func";
  import VioletBar from "../../Projects/VioletBar";
  import Fichette from "./Fichette";

  export default {
  name: "FichettesA5",
  components: {
    Fichette,
    VioletBar,
    Page,
    PageInner,
    SlidingWindow,
    PageFormatHandler
  },
  data() {
    return {
      projects: [],
      sortedProjects: [],
      loading: false,
      render: null,
      pm: {
        format: "A4"
      }
    };
  },
  props: {
    ids: {}
  },
  computed: {
    pagesLength() {
      return this.projects.length;
    },
    chunkedProjects() {
      return this.projects.reduce(
        (b, a) => {
          if (b[b.length - 1].length < 2) {
            b[b.length - 1].push(a);
          } else {
            b.push([a]);
          }
          return b;
        },
        [[]]
      );
    }
  },
  methods: {
    formatNumbers,
    mapNames,
    formatDateFrench,
    sortProjects() {
      return this.projects;
    },
    printManual() {
      this.$store.commit("setDrawingRatio", 1);
      setTimeout(() => {
        window.print();
      }, 300);
    },
    async print() {
      this.loading = true;
      await new Promise(r => setTimeout(r, 500));
      const render = await this.$store.dispatch(types.EXPORT_A4_PROJECT, {
        payload: JSON.stringify(this.$data),
        url: window.location.href,
        range: `1-${this.pagesLength}`,
        timeout: 2000 + this.pagesLength * 100,
        friendly_name: `${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}-summary${
          this.title ? "-" + this.title : ""
        }.pdf`.replace(/(\s|\/|:)/gi, "-")
      });
      this.render = render;
      this.loading = false;
    }
  },
  async mounted() {
    if (window.HEADLESS) {
      this.$store
        .dispatch(types.GET_RENDERING_PAYLOAD, get("payload"))
        .then(d => {
          for (let prop in d) {
            this.$set(this, prop, d[prop]);
          }
          rem("payload");
        });
    } else {
      this.projects = await this.$store.dispatch(
        t.GET_PROJECTS_BY_IDS_D,
        this.ids
      );
      this.sortedProjects = this.projects;
      rem("payload");
    }
  }
};
</script>

<style lang="scss">
.FichettesA5 {
  font-size: 11px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .half {
    height: 100%;
    width: 50%;
    position: absolute;
    top: 0;
    padding-top: 1cm;
    &:first-child {
      left: 0;
      padding-right: 1.5cm;
    }
    &:last-child {
      right: 0;
      padding-left: 1.5cm;
    }
  }
  h2 {
    font-size: 18px;
  }

  h3 {
    font-size: 14px;
  }
}
</style>
